import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { X, Tag } from "@phosphor-icons/react";
import { api } from "@/lib/api";

const DISMISS_KEY = "lumina_promo_dismissed";

export const PromoBanner = () => {
  const location = useLocation();
  const [promo, setPromo] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/promos/active");
        if (data.active && localStorage.getItem(DISMISS_KEY) !== data.code) {
          setPromo(data);
        }
      } catch (_) {
        // banner is best-effort
      }
    })();
  }, []);

  const onStore = location.pathname.startsWith("/studio") || location.pathname.startsWith("/book");
  if (!promo || !onStore) return null;

  const until = new Date(promo.valid_until).toLocaleDateString(undefined, { month: "short", day: "numeric" });

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(promo.code);
    } catch (_) {
      const ta = document.createElement("textarea");
      ta.value = promo.code;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div
      data-testid="promo-banner"
      className="relative z-40 bg-[#B45309]/15 border-b border-[#B45309]/30 backdrop-blur-sm"
    >
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-center gap-3 text-xs sm:text-sm">
        <Tag size={14} className="text-[#F59E0B] shrink-0" />
        <span className="text-white/80">
          {promo.percent_off}% off every ebook until {until} — code
        </span>
        <button
          data-testid="promo-banner-code"
          onClick={copy}
          title="Click to copy"
          className="font-mono tracking-[0.2em] text-[#F59E0B] border border-dashed border-[#F59E0B]/50 px-2.5 py-0.5 hover:bg-[#F59E0B]/10 transition-colors"
        >
          {copied ? "COPIED!" : promo.code}
        </button>
        <button
          data-testid="promo-banner-dismiss"
          onClick={() => {
            localStorage.setItem(DISMISS_KEY, promo.code);
            setPromo(null);
          }}
          className="absolute right-3 text-white/40 hover:text-white transition-colors"
          aria-label="Dismiss"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};
